import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useScreenInit } from '../useScreenInit.js';
import { SERVICE_PAGES } from '../lib/servicePages';
import { ServicePageTemplate } from '../components/service/ServicePageTemplate';
export function ServicePage() {
  useScreenInit();
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  if (slug === 'not-sure') return <Navigate to="/enquiry" replace data-id="element-526" />;
  const data = slug ? SERVICE_PAGES[slug] : undefined;
  if (!data) return <Navigate to="/" replace data-id="element-527" />;
  return <ServicePageTemplate data={data} data-id="element-528" />;
}